import { useState } from "react";

import { Button } from "../../components/Button";
import { nl } from "../../i18n/nl";
import styles from "./auth.module.css";

const t = nl.auth.codes;

function download(codes: string[]) {
  const text = [t.fileHeader, "", ...codes, ""].join("\n");
  const url = URL.createObjectURL(new Blob([text], { type: "text/plain;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = t.fileName;
  link.click();
  URL.revokeObjectURL(url);
}

/** Shown once after registration; the student must confirm before continuing. */
export function RecoveryCodes({ codes, onDone }: { codes: string[]; onDone: () => void }) {
  const [confirmed, setConfirmed] = useState(false);
  const [copied, setCopied] = useState(false);
  return (
    <section aria-labelledby="codes-title">
      <h1 id="codes-title" className={styles.title}>
        {t.title}
      </h1>
      <p className={styles.lead}>{t.text}</p>
      <ul className={styles.codes} aria-label={t.title}>
        {codes.map((code) => (
          <li key={code}>{code}</li>
        ))}
      </ul>
      <div className={styles.row}>
        <Button
          onClick={() => {
            void navigator.clipboard.writeText(codes.join("\n")).then(() => {
              setCopied(true);
            });
          }}
        >
          {copied ? t.copied : t.copy}
        </Button>
        <Button
          onClick={() => {
            download(codes);
          }}
        >
          {t.download}
        </Button>
      </div>
      <label className={styles.check}>
        <input
          type="checkbox"
          checked={confirmed}
          onChange={(event) => {
            setConfirmed(event.target.checked);
          }}
        />
        <span>{t.confirm}</span>
      </label>
      <Button
        variant="primary"
        size="large"
        className={styles.full}
        disabled={!confirmed}
        onClick={onDone}
        style={{ marginTop: 16 }}
      >
        {t.continue}
      </Button>
    </section>
  );
}
